import React from 'react'
import { translateNode } from 'src/localization/translateNode'

export const numberIsEmpty =
  (message?: string) =>
  (val?: number): React.ReactElement | undefined =>
    val === undefined
      ? translateNode(message !== undefined ? message : 'Must not be blank')
      : undefined

export const numberIsBelowMin =
  (min: number, message?: string) =>
  (val?: number): React.ReactElement | undefined =>
    val !== undefined && val < min
      ? translateNode(
          message !== undefined ? message : 'Must be greater than ${min}',
          {
            min: `${min}`,
          },
        )
      : undefined

export const numberMustBeGreaterThan =
  (min: number, message?: string) =>
  (val?: number): React.ReactElement | undefined =>
    val !== undefined && val <= min
      ? translateNode(
          message !== undefined ? message : 'Must be greater than ${min}',
          {
            min: `${min}`,
          },
        )
      : undefined

export const numberIsLuhnValid = (
  val?: number,
): React.ReactElement | undefined => {
  let nCheck = 0
  let nDigit = 0
  let bEven = false
  const cleanVal = (val + '')?.replace(/\D/g, '')

  if (cleanVal && cleanVal.length > 0) {
    for (let n = cleanVal.length - 1; n >= 0; n--) {
      const cDigit = cleanVal.charAt(n)
      nDigit = parseInt(cDigit, 10)

      if (bEven) {
        if ((nDigit *= 2) > 9) nDigit -= 9
      }

      nCheck += nDigit
      bEven = !bEven
    }

    return nCheck % 10 !== 0 || cleanVal.length > 16 || cleanVal.length < 15
      ? translateNode('Please enter a valid card number')
      : undefined
  } else {
    return translateNode('Please enter a valid card number')
  }
}
